import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Drawer from 'material-ui/Drawer';
import closeCalendarMessagingSummaryDrawer from '../state/closeCalendarMessagingSummaryDrawer';
import CONF from '../../../api/config';

const NOW = Date.now();

const CalendarMessagingSummaryDrawer = props => {
    const dispatch = useDispatch();

    const isOpen = useSelector(state => {
        return state.messagingSummaryDrawer.open;
    });

    const path = useSelector(state => {
        const teamId = state.messagingSummaryDrawer.teamId;
        const programWorkoutId = state.messagingSummaryDrawer.programWorkoutId;
        const title = state.messagingSummaryDrawer.title;
        const date = state.messagingSummaryDrawer.date;
        const athleteId =
            state.calendar.infoTree.athleteId ||
            state.messagingSummaryDrawer.athleteId;

        const messagingRoot = `${CONF.ADAPTER}/messaging/session`;
        const queryString = `?athleteId=${athleteId ||
            ''}&date=${date}&title=${title}&timestamp=${NOW}`;
        return `${messagingRoot}/${teamId}/${programWorkoutId}${queryString}`;
    });

    const onClose = () => {
        dispatch(closeCalendarMessagingSummaryDrawer());
        props.callback && props.callback();
    };

    return (
        <Drawer
            className="h-drawer"
            anchor="right"
            onClose={onClose}
            open={isOpen}
        >
            <div style={{ width: 400 }} />
            <iframe
                title="Messaging"
                src={path}
                frameBorder="0"
                style={{
                    width: '100%',
                    height: '100vh'
                }}
                allowFullScreen
            />
        </Drawer>
    );
};

export default CalendarMessagingSummaryDrawer;
